import { createDomain, sample } from 'effector'
import { leadLoginFx } from '~/features/auth/Login/model'
import { AxiosErrorType, Driver } from '~/shared/api'
import { logger } from '~/shared/lib/logger'
import { mapJsonApiMessageErrors } from '~/shared/lib/mapMessageErrors'
import { snackbarEnqueued } from '~/shared/lib/notifications'
import { leadRegistrationFormModel } from './BasicInformationStep/ui/Form'
import { goToConfirmCodeStep, goToErrorStep } from './stepModel'

const domain = createDomain('features.simplifiedRegistration')

type LeadRegistrationValues = {
  taxiparkId: string
  captchaToken: string
} & leadRegistrationFormModel.FormValues

export const leadRegistration = domain.createEvent<LeadRegistrationValues>()
export const leadRegistrationFx = domain.createEffect<
  LeadRegistrationValues,
  void,
  AxiosErrorType
>({
  async handler({ taxiparkId, captchaToken, ...arg }) {
    const driver = new Driver(arg)
    driver.setTaxipark(taxiparkId)
    await driver.createLead(captchaToken)
  },
})

export const leadLogin = domain.createEvent<{
  phone: string
  code: string
}>()

sample({
  clock: leadLogin,
  target: leadLoginFx,
})

sample({
  clock: leadRegistration,
  target: leadRegistrationFx,
})

sample({
  clock: leadRegistrationFx.doneData,
  target: goToConfirmCodeStep,
})

sample({
  clock: leadRegistrationFx.failData,
  fn(e) {
    logger.error(e)
    return {
      message: mapJsonApiMessageErrors(e),
      variant: 'danger' as const,
    }
  },
  target: snackbarEnqueued,
})

sample({
  clock: leadRegistrationFx.failData,
  filter: (e) => e?.response?.status !== 422,
  target: goToErrorStep,
})
